import { writable } from 'svelte/store';
import { browser } from '$app/environment';

// type CommunityPostsState = {
// 	posts: any[];
// 	currentPage: number;
// 	scrollPosition: number;
// 	totalPosts: number;
// };

const STORE_KEY = 'communityPostsState';

// function getInitialState(): CommunityPostsState {
// 	if (browser) {
// 		const stored = sessionStorage.getItem(STORE_KEY);
// 		if (stored) {
// 			console.log('Restored state from session:', JSON.parse(stored));
// 			return JSON.parse(stored);
// 		}
// 	}
// 	console.log('Using default state');
// 	return {
// 		posts: [],
// 		currentPage: 0,
// 		scrollPosition: 0,
// 		totalPosts: 0
// 	};
// }

const createCommunityPostsStore = () => {
	const { subscribe, set, update } = writable({
		posts: [],
		currentPage: 0,
		totalPosts: 0,
		scrollPosition: 0
	});

	if (browser) {
		subscribe((state) => {
			// console.log('Saving state:', state);
			sessionStorage.setItem(STORE_KEY, JSON.stringify(state));
		});
	}

	return {
		subscribe,
		setPosts: (posts: any[]) => update((state) => ({ ...state, posts })),
		setPage: (page: number) => update((state) => ({ ...state, currentPage: page })),
		setScrollPosition: (position: number) =>
			update((state) => ({ ...state, scrollPosition: position })),
		setTotalPosts: (total: number) => update((state) => ({ ...state, totalPosts: total })),
		reset: () => {
			// console.log('Store reset called');
			if (browser) {
				// Clear all storage
				sessionStorage.removeItem(STORE_KEY);
				localStorage.removeItem(STORE_KEY);
			}
			set({
				posts: [],
				currentPage: 0,
				scrollPosition: 0,
				totalPosts: 0
			});
		}
	};
};

export const communityPostsStore = createCommunityPostsStore();
